
{
  "familyId": "SPR-HOOFDLETTER",
  "questions": [
    {
      "id": "SPR-HOOFDLETTER-001",
      "familyId": "SPR-HOOFDLETTER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "hoofdletter_gebruik",
      "questionType": "multiple_choice",
      "question": "Welk woord moet met een hoofdletter worden geschreven?",
      "context": "Vul de zin aan: '... woont in amsterdam.'",
      "options": ["Emma", "emma", "EMMA", "emMa"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Hoofdletterregels", "content": "Gebruik een hoofdletter bij: namen van personen (Emma, Jan), namen van plaatsen (Amsterdam, Nederland), begin van een zin.", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "hoofdletter_naam",
      "variantIndex": 1,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Namen van personen schrijf je altijd met een hoofdletter. Emma is een naam, dus schrijf je 'Emma' met een hoofdletter E.",
        "distractorExplanations": {
          "0": "Correct! Namen van personen schrijf je met een hoofdletter: Emma.",
          "1": "Fout: 'emma' begint met een kleine letter. Namen van personen schrijf je altijd met een hoofdletter: Emma.",
          "2": "Fout: je schrijft niet alle letters als hoofdletter. Alleen de eerste letter is een hoofdletter: Emma.",
          "3": "Fout: alleen de eerste letter van een naam is een hoofdletter: Emma, niet emMa."
        }
      }
    },
    {
      "id": "SPR-HOOFDLETTER-002",
      "familyId": "SPR-HOOFDLETTER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "hoofdletter_gebruik",
      "questionType": "multiple_choice",
      "question": "Welke zin is correct geschreven?",
      "context": null,
      "options": [
        "de hond rent door het park.",
        "De hond rent door het park.",
        "De Hond rent door het park.",
        "De hond Rent door het park."
      ],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Begin van een zin", "content": "Het eerste woord van een zin schrijf je altijd met een hoofdletter.", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "hoofdletter_zinsbegin",
      "variantIndex": 2,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Het eerste woord van een zin schrijf je altijd met een hoofdletter. 'De' is het eerste woord, dus schrijf je 'De' met een hoofdletter D.",
        "distractorExplanations": {
          "0": "Fout: 'de' begint met een kleine letter, maar het eerste woord van een zin moet een hoofdletter hebben: 'De hond...'",
          "1": "Correct! 'De' begint met een hoofdletter omdat het het eerste woord van de zin is.",
          "2": "Fout: 'Hond' is geen naam en staat niet aan het begin van de zin. Gewone woorden in het midden van een zin krijgen geen hoofdletter.",
          "3": "Fout: 'Rent' is een gewoon werkwoord in het midden van de zin. Dat krijgt geen hoofdletter."
        }
      }
    },
    {
      "id": "SPR-HOOFDLETTER-003",
      "familyId": "SPR-HOOFDLETTER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "hoofdletter_gebruik",
      "questionType": "multiple_choice",
      "question": "Welk woord moet in deze zin een hoofdletter hebben?\n'gisteren bezochten we ... met de klas.'",
      "context": null,
      "options": ["amsterdam", "Amsterdam", "AMSTERDAM", "AmsterDam"],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Plaatsnamen", "content": "Namen van steden, landen en plaatsen schrijf je altijd met een hoofdletter: Amsterdam, Nederland, Europa.", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "hoofdletter_plaatsnaam",
      "variantIndex": 3,
      "citoDifficulty": 0.24,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Namen van steden en plaatsen schrijf je altijd met een hoofdletter. Amsterdam is een stad, dus schrijf je 'Amsterdam' met een hoofdletter A.",
        "distractorExplanations": {
          "0": "Fout: plaatsnamen schrijf je met een hoofdletter. Het is 'Amsterdam', niet 'amsterdam'.",
          "1": "Correct! Amsterdam is een plaatsnaam en schrijf je met een hoofdletter A.",
          "2": "Fout: je schrijft niet alle letters als hoofdletter. Alleen de eerste letter is een hoofdletter: Amsterdam.",
          "3": "Fout: alleen de eerste letter van een plaatsnaam is een hoofdletter: Amsterdam, niet AmsterDam."
        }
      }
    },
    {
      "id": "SPR-HOOFDLETTER-004",
      "familyId": "SPR-HOOFDLETTER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "hoofdletter_gebruik",
      "questionType": "multiple_choice",
      "question": "In welke zin zijn alle hoofdletters correct gebruikt?",
      "context": null,
      "options": [
        "mijn vriend thomas woont in Rotterdam.",
        "Mijn vriend Thomas woont in Rotterdam.",
        "Mijn Vriend Thomas woont in Rotterdam.",
        "Mijn vriend thomas woont in rotterdam."
      ],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Overzicht hoofdletterregels", "content": "Hoofdletter bij: 1) begin van een zin, 2) namen van personen, 3) namen van plaatsen. Gewone woorden zoals 'vriend' krijgen geen hoofdletter.", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "hoofdletter_combinatie",
      "variantIndex": 4,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "In de correcte zin: 'Mijn' heeft een hoofdletter (begin van de zin), 'Thomas' heeft een hoofdletter (persoonsnaam), 'Rotterdam' heeft een hoofdletter (plaatsnaam). Het woord 'vriend' is een gewoon woord en krijgt geen hoofdletter.",
        "distractorExplanations": {
          "0": "Fout: 'mijn' begint de zin en moet een hoofdletter hebben. Ook 'thomas' is een naam en moet 'Thomas' zijn.",
          "1": "Correct! 'Mijn' (zinsbegin), 'Thomas' (naam) en 'Rotterdam' (plaatsnaam) hebben alle drie terecht een hoofdletter.",
          "2": "Fout: 'Vriend' is een gewoon woord en staat niet aan het begin van de zin. Gewone woorden krijgen geen hoofdletter.",
          "3": "Fout: 'thomas' (naam) moet 'Thomas' zijn, en 'rotterdam' (plaatsnaam) moet 'Rotterdam' zijn."
        }
      }
    },
    {
      "id": "SPR-HOOFDLETTER-005",
      "familyId": "SPR-HOOFDLETTER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "hoofdletter_gebruik",
      "questionType": "multiple_choice",
      "question": "Welke woorden hoeven GEEN hoofdletter in deze zin?\n'Op maandag gaat Lisa naar school in Nederland.'",
      "context": null,
      "options": ["maandag en school", "Lisa en Nederland", "school en maandag", "alleen Lisa"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Wanneer geen hoofdletter?", "content": "Gewone zelfstandige naamwoorden (school, huis) en dagen van de week (maandag, dinsdag) krijgen in het Nederlands GEEN hoofdletter. Wel een hoofdletter bij: namen van personen (Lisa) en landen (Nederland).", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "hoofdletter_geen",
      "variantIndex": 5,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "In het Nederlands schrijf je dagen van de week (maandag, dinsdag) en gewone zelfstandige naamwoorden (school, huis) met een kleine letter. Persoonsnamen (Lisa) en landnamen (Nederland) krijgen wél een hoofdletter.",
        "solutionSteps": [
          "'maandag' = dag van de week → kleine letter",
          "'school' = gewoon zelfstandig naamwoord → kleine letter",
          "'Lisa' = persoonsnaam → hoofdletter",
          "'Nederland' = landnaam → hoofdletter"
        ],
        "distractorExplanations": {
          "0": "Goed! In het Nederlands schrijf je dagen (maandag) en gewone woorden (school) met een kleine letter. Alleen namen van personen en plaatsen krijgen een hoofdletter.",
          "1": "Lisa is een persoonsnaam en Nederland is een landnaam — die krijgen juist wél een hoofdletter. De woorden zonder hoofdletter zijn 'maandag' en 'school'.",
          "2": "De volgorde is omgedraaid, maar de woorden kloppen: zowel 'school' als 'maandag' krijgen geen hoofdletter. Let op: dit antwoord is hetzelfde als antwoord A.",
          "3": "Lisa krijgt juist wél een hoofdletter (persoonsnaam). De woorden zonder hoofdletter zijn 'maandag' (dag van de week) en 'school' (gewoon woord)."
        }
      }
    }
  ]
}
